import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'issues-emergency-freq-grid-item',
    templateUrl: './issues-emergency-freq-grid-item.component.html'
})

export class IssuesEmergencyFreqGridItemComponent implements OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private dataService: DataService
    ) {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['emergencyFreqPage']) {
                    this.page = +queryParams['emergencyFreqPage'];
                }
            }));

        this.getData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.issuePaygEmergencyCreditFrequencyDetail(this.clientId, this.page, this.pageSize, this.siteId).then(
            result => {
                if (result && result.items.length > 0) {
                    this.dataService.issuePaygEmergencyCreditFrequencyDetailResolved.next(true);
                    this.data = result.items;
                    this.totalPages = result.totalPages;
                    this.pageSize = result.pageSize;
                
                } else { this.dataService.issuePaygEmergencyCreditFrequencyDetailResolved.next(false); }
            },
            error => this.dataService.issuePaygEmergencyCreditFrequencyDetailResolved.next(false)
        );
    }

    onInfoClick() {
        swal({
            title: 'Consumer behaviour with E/C',
            html: '<p style="text-align: left;">This shows consumers who are currently using emergency credit and how often they have entered it within the last 60 days.</p>\
            <p style="text-align: left;">You should pay attention to consumers who use emergency credit frequently as they are vulnerable to running out of utility supply and pose a debt risk to your organisation. \
                                        Consumers should be encouraged to maintain healthy levels of credit at all times to prevent this.</p>\
            <p style="text-align: left;">Check out their consumer page for more information on their credit levels and emergency credit usage.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
